/* global Tena */

(function($) {
    Tena.Footer = {
        canvas: null,
        canvasColor: null,

        init: function() {
            Tena.Footer.initCanvas();
            Tena.Footer.shareLinksWindow();
        },

        initCanvas: function() {
            var $container = $('#footer-effect'),
                canvas = $('<canvas/>').prependTo($container).get(0);

            if (!canvas.getContext) {
                return;
            }

            Tena.Footer.canvas = canvas;
            Tena.Footer.canvasColor = $container.css('background-color');

            $container.addClass('effect');

            $(window).resize(function() {
                Tena.Footer.drawCanvas($container);
            });

            Tena.Footer.drawCanvas($container);
        },

        drawCanvas: function($container) {
            var height = $container.height(),
                width = window.innerWidth,
                start = [0, 0.5 * height];

            Tena.Footer.canvas.width = width;
            Tena.Footer.canvas.height = height;

            var ctx = Tena.Footer.canvas.getContext('2d');
            ctx.fillStyle = Tena.Footer.canvasColor;
            ctx.beginPath();
            ctx.moveTo(start[0], start[1]);
            ctx.quadraticCurveTo(0, height, 0.5 * height, height);
            ctx.lineTo((width - 1.6) * height, height);
            ctx.quadraticCurveTo(width, height, width, 0);

            ctx.lineTo(width, height);
            ctx.lineTo(0, width);
            ctx.lineTo(0, 0);
            ctx.fill();
        },

        shareLinksWindow: function() {
            $('#share-link-popup-link').magnificPopup({
                type: 'inline'
            });
        }
    };
})(jQuery);
